// Advisory copy for the Rewrite page. Twin of proxy-server/iuRewrite.js
// ppidLengthWarning / PPID_LENGTH_WARNING; both are pinned by the same boundary table.
// Wording is hedged on purpose: 22-150 on DAI is unverified, so never say DAI ignores it.

export const PPID_LENGTH_WARNING =
  'PPID is outside 22-150 characters (knowledge pack gma_ppid). Google may ignore it. Saving is still allowed.';

export const GAM_BODY_HINT =
  'Query-param rules for GAM (add or remove) also apply to DAI stream-create form bodies (POST .../streams), not to USB/logcat rows.';

/** Advisory only. Case-sensitive key, raw trimmed value length. Never throws. */
export function ppidLengthWarning(field, key, value) {
  try {
    if (field !== 'paramAdd' || String(key == null ? '' : key).trim() !== 'ppid') return null;
    const n = String(value == null ? '' : value).trim().length;
    return n < 22 || n > 150 ? PPID_LENGTH_WARNING : null;
  } catch (_) {
    return null;
  }
}

/** Hint for an enabled GAM-target add/remove query-param rule. Never throws. */
export function gamBodyHint(rule) {
  try {
    if (!rule) return null;
    if (rule.field !== 'paramAdd' && rule.field !== 'paramRemove') return null;
    if (!(rule.targets && rule.targets.gam)) return null;
    if (rule.enabled === false) return null;
    return GAM_BODY_HINT;
  } catch (_) {
    return null;
  }
}
